export const ITEMS_PER_PAGE = 20;
export const PAGE_SIZE = [10, 20, 30, 50, 100];
export const ASC = 'asc';
export const DESC = 'desc';
export const SORT = 'sort';
export const ITEMS_PER_PAGE_REPORT_SCHEDULE = 30;
export const PAGE_SIZE_REPORT_SCHEDULE = [30, 50];
